import React from 'react';
import { Container, Step, Button, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const HowItWorks = () => (
  <Container text style={{ padding: '2em 1em', maxWidth: 768, margin: '0 auto' }}>
    <Header className='centered'>Simple & Smart</Header>
    <Step.Group horizontal size='large' style={{ justifyContent: 'space-between' }}>
      <Step style={{ width: 'calc(33.33% - 10px)' }}>
        <Step.Title as='h3' style={{ fontSize: '1.5em' }}>Sign Up</Step.Title>
        <Step.Description style={{ fontSize: '1em' }}>Create an account.</Step.Description>
      </Step>
      <Step style={{ width: 'calc(33.33% - 10px)' }}>
        <Step.Title as='h3' style={{ fontSize: '1.5em' }}>Upload Icon</Step.Title>
        <Step.Description style={{ fontSize: '1em' }}>Upload your icon.</Step.Description>
      </Step>
      <Step style={{ width: 'calc(33.33% - 10px)' }}>
        <Step.Title as='h3' style={{ fontSize: '1.5em' }}>Get Animated Icon</Step.Title>
        <Step.Description style={{ fontSize: '1em' }}>Our AI will animate your icon.</Step.Description>
      </Step>
    </Step.Group>
    <Button primary size='large' as={Link} to='/signup' style={{ margin: '20px auto', display: 'block' }}>
      Start Now
    </Button>
  </Container>
);

export default HowItWorks;
